import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-enroll-now',
  imports: [RouterModule,CommonModule],
  templateUrl: './enroll-now.component.html',
  styleUrl: './enroll-now.component.css'
})
export class EnrollNowComponent {
review:any[]=[];
dynamicImage:any;
    ngOnInit() {
   this.review_Image()
  }

  review_Image() {
    this.review = [

      {
        img: "../assets/images/all-instructor/contact-review-1.png",
      },
      {
        img: "../assets/images/all-instructor/contact-review-2.png",
      },
    
      {
        img: "../assets/images/all-instructor/contact-review-3.png",
      },            
    ]
    const randomIndex = Math.floor(Math.random() * this.review.length);
    this.dynamicImage = this.review[randomIndex].img;
  }

}
